import template from './ticketRealEstate.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    realEstate: '<',
    countries: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      $mdUtil,
      TicketLoanPropertySplit,
      TicketTitleDetail,
      TicketLoanFee,
      TicketLoanFeeType,
      CertificateOfTitle,
      TypeOfCertificateOfTitle,
      OwnershipType,
      PropertyType,
      helperService,
      dateTimeService
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.contacts = [];
      ctrl.currentOrganization = null;
      ctrl.currentCurrency = null;
      ctrl.currentDateFormat = null;
      ctrl.organizationCountry = '';
      ctrl.organizationVat = 0;
      ctrl.availableRealEstateFeeTypes = [];
      ctrl.availableOwnershipTypes = [];
      ctrl.availablePropertyTypes = [];
      ctrl.availableCertificatesOfTitle = [];
      ctrl.availableTypesOfCertificateOfTitle = [];
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.organizationVat = helperService.getOrganizationVat();
        ctrl.availableRealEstateFeeTypes = helperService.getAvailableRealEstateFeeTypes();
        ctrl.availableOwnershipTypes = OwnershipType.available();
        ctrl.availablePropertyTypes = PropertyType.available();
        ctrl.availableCertificatesOfTitle = CertificateOfTitle.available();
        ctrl.availableTypesOfCertificateOfTitle = TypeOfCertificateOfTitle.available();
        ctrl.realEstate = ctrl.realEstate || {};
        ctrl.countries = ctrl.countries || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        dateTimeService.getSet(
          ctrl,
          ctrl.realEstate,
          'lastSaleTimestamp',
          'getSetLastSaleTimeStamp'
        );
        ctrl.isReady = true;
      };

      ctrl.ticketRealEstatePropertySplitAdd = () => {
        ctrl.realEstate.dealRealEstatePropertySplit.push(TicketLoanPropertySplit.blank());
        ctrl.realEstateTitleDetailAdd(
          ctrl.realEstate.dealRealEstatePropertySplit[
            ctrl.realEstate.dealRealEstatePropertySplit.length - 1
          ].id
        );
      };

      ctrl.ticketRealEstatePropertySplitDelete = (index) => {
        ctrl.realEstateTitleDetailDelete(ctrl.realEstate.dealRealEstatePropertySplit[index].id);
        ctrl.realEstate.dealRealEstatePropertySplit.splice(index, 1);
        ctrl.saveTicketRealEstate();
      };

      ctrl.ticketRealEstateFeeAdd = ($event, feeType) => {
        $event.stopPropagation();
        ctrl.realEstate.fees.push(TicketLoanFee.blank(feeType));
      };

      ctrl.ticketRealEstateFeeDelete = (index) => {
        ctrl.realEstate.fees.splice(index, 1);
        ctrl.saveTicketRealEstate();
      };

      ctrl.isFeeTypeCommission = (id) => id === TicketLoanFeeType.available()[1].id;

      ctrl.realEstateTitleDetailAdd = (idSecurity) => {
        ctrl.realEstate.titleDetails.push(TicketTitleDetail.blank(idSecurity));
      };

      ctrl.realEstateTitleDetailDelete = (idSecurity) => {
        const index = _.findIndex(
          ctrl.realEstate.dealRealEstatePropertySplit,
          (pS) => pS.idSecurity === idSecurity
        );
        if (index > -1) {
          ctrl.realEstate.titleDetails.splice(index, 1);
        }
      };

      ctrl.getPropertyName = (idSecurity) => {
        const property = ctrl.realEstate.dealRealEstatePropertySplit.find(
          (pS) => pS.id === idSecurity
        );
        return property?.address?.formatted || 'New property';
      };

      ctrl.toggleGstVat = (feeToEdit) => {
        const fee = feeToEdit;
        if (fee.isGstVatApplicable) {
          fee.amount += fee.amount * ctrl.organizationVat.decimal;
        } else {
          fee.amount /= ctrl.organizationVat.decimal + 1;
        }
        ctrl.saveTicketRealEstate();
      };

      /*
       * Save ticket real estate
       * --------------------------------------------------------------------------------
       */
      ctrl.saveTicketRealEstate = () => ctrl.onFinished({ realEstate: ctrl.realEstate });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
